import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Dropdown} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {startsWith} from '../../../../common/util/dropdown';

class ProductCodeSelector extends Component {
  componentDidMount() {
    this.props.fetchPriceFactorsProductCodes();
  }

  parseProductCodes(poductCodes = []) {
    return poductCodes.map((item) => ({'text': item?.productCode ? item.productCode : '',
      'value': item?.productCode ? item.productCode : ''}));
  }

  render() {
    const {value, name, priceFactorsProductCodes, priceFactorsProductCodesLoading, changeValue} = this.props;
    return (
      <Dropdown selection fluid
        name={name}
        search={startsWith}
        value={value}
        loading={priceFactorsProductCodesLoading}
        disabled={priceFactorsProductCodesLoading}
        options={this.parseProductCodes(priceFactorsProductCodes)}
        onChange={changeValue}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'priceFactorsProductCodesLoading': state.priceFactorsProductCodes.loading,
    'priceFactorsProductCodes': state.priceFactorsProductCodes.list,
  };
};

const {fetchPriceFactorsProductCodes} = Actions;

export default connect(mapStateToProps, {fetchPriceFactorsProductCodes})(ProductCodeSelector);
